import React, { useState, useEffect } from "react";
import styled from 'styled-components';
import Card from './Card'
import TestImage from '../images/olivia_rodrigo.svg';
import { mediaQueries, fonts } from '../shared/config'
import mobile1 from '../images/mobilebackground.svg';
import mobile2 from '../images/Slice 2.svg';
import mobile3 from '../images/Slice 3.svg';
import mobile4 from '../images/Slice 4.svg';
import SpotifyEmbed from "./SpotifyEmbed"
import background1 from '../images/background1.svg';
import background2 from '../images/background2.svg';
import background3 from '../images/background3.svg';
import background4 from '../images/background4.svg';

const ParentGrid = styled.div`
    display: grid;
    padding-top: 10%;
    padding-bottom: 10%;
    grid-template-columns: 32vw 32vw;
    
    column-gap: 16vw;
    justify-content: center;
    ${mediaQueries.mobile} {
        grid-template-columns: 100vw;
        grid-template-rows: auto auto;
        row-gap: 100px;
        width: 250px;
        margin: 0 auto;
    }
`

// Calculate pixel values for row layout
const rowGap = 100;
const rowHeight = 476; // Height of card
const mobilerowHeight = 275;
const halfRowOffset = (rowGap + rowHeight) / 2;

const Grid1 = styled.div`
    margin-top: ${halfRowOffset}px;
    display: grid;
    width: 32vw;
    justify-items: center;
    align-items: center;
    grid-template-rows: repeat(auto-fill, ${rowHeight}px);
    row-gap: ${rowGap}px;
    grid-column: 1;
    ${mediaQueries.mobile} {
        grid-template-rows: repeat(auto-fill, ${mobilerowHeight}px);
        margin-top: 0px;
        grid-row: 1;
        width: 100vw;
    }
`

const Grid2 = styled.div`
    display: grid;
    width: 32vw;
    justify-items: center;
    align-items: center;
    grid-template-rows: repeat(auto-fill, 476px);
    row-gap: ${rowGap}px;
    grid-column: 2;
    ${mediaQueries.mobile} {
        grid-template-rows: repeat(auto-fill, ${mobilerowHeight}px);
        grid-column: 1;
        grid-row: 2;
        width: 100vw;
    }
`

export default function ArticleGrid(props) {
    function getBackground (section) {
        if (section == "jazz") {return background1};
        if (section == "contemporary") {return background2};
        if (section == "other") {return background3};
        if (section == "related") {return background4};
    }
    function getBackgroundMobile(section) {
        if (section == "jazz") {return mobile1};
        if (section == "contemporary") {return mobile2};
        if (section == "other") {return mobile3};
        if (section == "related") {return mobile4};
    }
    const media = window.matchMedia('(max-width: 750px)');
    const [isMobile, setIsMobile] = useState(media.matches);
    media.addEventListener('change', () => {
        if (media.matches !== isMobile) {
          setIsMobile(media.matches);
        }
    });
    const Container = styled.div ` 
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        background-image: url(${getBackground(props.section)});
        background-size: 100% auto;
        background-repeat: no-repeat;
        height: 100%;
        width: 100%;
        ${mediaQueries.mobile} {
            background-image: url(${getBackgroundMobile(props.section)});
            background-size: 100% auto;
            background-repeat: repeat-y;
        }
    `
    
    return (
        <Container>
        <ParentGrid>
            <Grid1>
                {props && props.articles ? props.articles.map((article) => {
                    console.log(article.type); 
                    if(isMobile && article.type == "spotify") {
                        return(
                            <Card type={article.type} articleLink={article.link} />
                        )
                    }
                    if ((article.type =="article" && article.side == "left")) {
                        console.log(article); 
                        return(
                            <Card type={article.type} articleLink={article.article_link} articleTitle={article.title} author={article.byline} image={article.image_link}/>
                        )
                    };  
                }) : null}
                
            </Grid1>
            <Grid2>
            {props && props.articles ? props.articles.map((article) => {
                    console.log(isMobile === false); 
                    if((isMobile === false) && article.type == "spotify") {
                        console.log("hi");
                        return(
                            <Card type={article.type} articleLink={article.link} />
                        )
                    }
                    if ((article.type =="article" && article.side == "right")) {
                        //console.log(article); 
                        return(
                            <Card type={article.type} articleLink={article.article_link} articleTitle={article.title} author={article.byline} image={article.image_link}/>
                        )
                    };  
                
                }) : null}
            </Grid2>    
        </ParentGrid>
        </Container>
    )
}